// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-__TideStationName-module___container src-styles-__global___sansSerifRegular","label":"src-components-__TideStationName-module___label","name":"src-components-__TideStationName-module___name"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TideStationName.module.css
// module id = 693
// module chunks = 0